import { roundToCents } from './Money.utils';

// An amount is clamped to whole cents so that everything downstream can compare and add up
// integers - a third decimal breaks the sum comparison against the Forderungssumme.
export const parseCurrency = (currencyString: string): number =>
  roundToCents(Number(sanitizeCurrencyInput(currencyString)));

// Here is a regexer link of a simplified version of this regex which removes all '.' and ','
// which are not the last one (i.e., after that comes one more '.' or ','):
// https://regexr.com/7v9e5
const sanitizeCurrencyInput = (currencyString: string): string =>
  currencyString
    .replaceAll(/[Oo]/g, '0') // replace all o's with 0's
    .replaceAll(/[^0-9.,-]/g, '') // remove all non-numeric characters
    // This regular expression performs several operations:
    // 1. `(?<=.)[-]`: Matches a minus sign `-` that is preceded by any character.
    // 2. `(?<=[.,])[-]`: Matches a minus sign `-` that is immediately preceded by a period `.` or a comma `,`.
    // 3. `[.,](?=.*[.,](?=.*\d))`: Matches a period `.` or a comma `,` if there's another period or comma followed by a digit somewhere ahead in the string.
    // 4. `[.,](?!.*\d)`: Matches a period `.` or a comma `,` if there's no digit anywhere ahead in the string.
    // The `|` operator denotes OR, meaning that the regular expression will match any of the four conditions.
    // The `g` flag means "global", so it will replace all matches in the string, not just the first one.
    // The `.replace(..., '')` function call replaces all matches of the regular expression with an empty string, effectively removing them from the original string.
    .replace(/(?<=.)[-]|(?<=[.,])[-]|[.,](?=.*[.,](?=.*\d))|[.,](?!.*\d)/g, '')
    // Only one separator is left at this point. A dot with exactly three digits behind it is a
    // thousands separator ("1.234" is 1234, not 1.23) - a comma stays the german decimal
    // separator. The leading digit must not be a zero, so "0.500" keeps its 50 cents.
    .replace(/(?<=[1-9]\d*)\.(?=\d{3}$)/, '')
    .replace(',', '.'); // replace comma with dot

export const sanitizeDateInput = (input: string): string =>
  input
    .trim()
    .replace(/[^0-9a-zA-Zä.\-/ ]/g, '')
    // März is the only month with an umlaut and "ä" is often recognized as "a" by ocr
    .replace('Marz', 'März')
    // remove all whitespaces that are not between a letter and a digit (or between a digit and a letter)
    // these exceptions keep one whitespace in "...Januar 20..." or "10 März", otherwise
    // such a date would not be parseable anymore (10März or Januar2020).
    // see: https://regexr.com/806b0
    // Note: "10 März" is actually not a common german format, but the period is often not recognized by the ocr
    .replace(/\s+(?!(?<=[a-zA-Z]\s+)\d)(?!(?<=\d\s+)[a-zA-Z])/g, '')
    //remove special characters at start and end
    .replace(/^[^\w\s]+|[^\w\s]+$/g, '');
